import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {




const goOrther = () => {
	var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
	if (is_mobi) {
		// 如果是移动端就跳转到移动端地址
		let params = new URL(window.location.href).pathname
		let baseurl = 'https://www.gnanoai.com/m' + params
		//  利用方法跳转到对应的页面
		window.location.href = baseurl
	} else {
	}
}
goOrther()



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view)
  ]))
}
}

})